
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import buscador from './lista-buscador.vue';
    import tipos from './lista-buscador-tipos.vue';
    import listado from './lista-listado.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            listado,
            tipos,
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Controlador.Buscador.Filtros.set( this.$route.query );
            this.Controlador.Buscador.Buscar();

        }


    }
